document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelectorAll("[data-marquee]").length) {
        const marquee = new Marquee();
        marquee.init();
    }
});

export default class Marquee {
    constructor() {
        this.init();
    }

    init() {
        const shortenElements = document.querySelectorAll(".marquee span.shorten");
        shortenElements.forEach(element => {
            element.textContent = element.textContent.substring(0, 140) + "...";
        });

        this.startMarquee("marquee", { speed: 10, delay: 500 });
    }

    extend(object1, object2) {
        for (let attrname in object2) {
            object1[attrname] = object2[attrname];
        }
        return object1;
    }

    startMarquee(id, param) {
        const tickerBox = document.getElementById(id);
        const defaultParam = { speed: 5, delay: 500, rotate: true };
        const extendedParam = this.extend(defaultParam, param);
        const ul = tickerBox.getElementsByTagName("ul")[0];
        const li = ul.getElementsByTagName("li");
        let liIndex = 0;
        let transWidth = tickerBox.offsetWidth;
        const chunkWidth = 1;
        let animationFrameId;

        const iterateTickerElement = (transWidth) => {
            li[liIndex].style.left = transWidth + "px";
            li[liIndex].style.display = "";

            const animate = () => {
                const currentLeft = parseInt(li[liIndex].style.left);
                if (currentLeft > -li[liIndex].offsetWidth) {
                    li[liIndex].style.left = currentLeft - chunkWidth + "px";
                    animationFrameId = requestAnimationFrame(animate);
                } else {
                    cancelAnimationFrame(animationFrameId);
                    transWidth = tickerBox.offsetWidth;
                    liIndex++;
                    if (liIndex == li.length && extendedParam.rotate) {
                        liIndex = 0;
                        iterateTickerElement(transWidth);
                    } else if (liIndex < li.length) {
                        setTimeout(() => {
                            iterateTickerElement(transWidth);
                        }, extendedParam.delay);
                    }
                }
            };

            animationFrameId = requestAnimationFrame(animate);

            tickerBox.onmouseover = () => {
                cancelAnimationFrame(animationFrameId);
            };
            tickerBox.onmouseout = () => {
                animationFrameId = requestAnimationFrame(animate);
            };
        };

        iterateTickerElement(transWidth);
    }
}
